import * as Qr from 'qrcode';
import {QRCodeRenderersOptions} from 'qrcode';
import {useCallback, useEffect, useState} from 'react';

import {Props} from './model';
import View from './view';

export const QrCode = (props: Props) => {
  const {text, size, scale = 12} = props;
  const [code, setCode] = useState<any>(null);
  const callback = useCallback((error: Error | null | undefined, result: string) => {
    if (!error) {
      setCode(result.toString());
    }
  }, []);
  useEffect(() => {
    const options: QRCodeRenderersOptions = {width: size, margin: 2, scale};
    Qr.toString(text, {...options, type: 'svg'}, callback);
  }, [text, size]);
  return View({
    ...props,
    code,
  });
};
